import {
  useIsFetching,
  type Query,
  type QueryObserver,
} from '@tanstack/react-query';

type UseLoadingStatus = {
  isLoadingEssentials: boolean;
  isLoadingAggregation: boolean;
};

const useLoadingStatus = (): UseLoadingStatus => {
  const isLoadingEssentials =
    useIsFetching({
      predicate: (query: Query): boolean => {
        return query.observers.some((observer: QueryObserver): boolean => {
          return observer.options.meta?.dataType === 'essentials';
        });
      },
    }) > 0;
  const isLoadingAggregation =
    useIsFetching({
      predicate: (query: Query): boolean => {
        return query.observers.some((observer: QueryObserver): boolean => {
          return observer.options.meta?.dataType === 'aggregation';
        });
      },
    }) > 0;

  return { isLoadingEssentials, isLoadingAggregation };
};

export { useLoadingStatus };
